import geomap from '../../assets/geo-map.png';
import quizicon from '../../assets/quiz-icon.avif';

export const getIcon = (icontype: string) => {
  switch (icontype) {
    case 'geoplay':
      return geomap;
    case 'quiz':
      return quizicon;
    default:
      return null;
  }
};
export const getGameLabel = (gameType: string) => {
  switch (gameType) {
    case 'geoplay':
      return '🌍 Geo Guess';
    case 'quiz':
      return '🧠 Quiz';
    case 'sketcher':
      return '🎨 Sketcher';
    default:
      return '🎮 Game';
  }
};
export const gamePlayStatus = (
  status: string | undefined
): string | undefined => {
  switch (status) {
    case 'LOBBY':
      return 'scheduled';
    case 'IN_PROGRESS':
      return 'active';
    case 'FINISHED':
      return 'ended';
    default:
      return 'ended';
  }
};
